import { SearchOutlined } from "@mui/icons-material";
import { InputAdornment, TextField } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import _ from "lodash";

const FavoritesSearch = ({ height, width }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentQuery = searchParams.get("fav_query") || "";

  const handleSearch = _.debounce((e) => {
    const query = e.target.value.trim();
    const params = new URLSearchParams(searchParams);

    if (query) {
      params.set("fav_query", query);
    } else {
      params.delete("fav_query");
    }

    setSearchParams(params);
  }, 500);

  return (
    <TextField
      defaultValue={currentQuery}
      onChange={handleSearch}
      sx={{ height, width: width ? width : "100%" }}
      type="text"
      placeholder={"جستجو : علاقمندی"}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchOutlined sx={{ width: "24px" }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default FavoritesSearch;
